const { Office } = window;

// Need to wait for Office to be ready befor assigning
let mailbox = null;
Office.onReady(() => {
  mailbox = Office.context.mailbox;
});

export const setBccInOutlook = (emailArray) =>
  mailbox && mailbox.item.bcc.setAsync(emailArray);

export const getOutlookEmailAddress = () =>
  mailbox && mailbox.userProfile.emailAddress;

// Lower-cases and trims an email address for case-insensitive comparison.
// Office.js can return sender addresses in inconsistent casing, so never
// compare raw address strings directly.
export const normalizeEmailAddress = (email) =>
  (email || '').toString().trim().toLowerCase();

// True only for a real SMTP address (user@domain.tld). Office.js can hand back
// an Exchange X500 / legacyExchangeDN form (e.g. "/o=ExchangeLabs/ou=.../cn=...")
// for internal senders, which must NOT be treated as a comparable address.
export const isSmtpAddress = (email) =>
  /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(normalizeEmailAddress(email));

export const prependToOutlookMessageBody = (htmlString) =>
  mailbox &&
  mailbox.item.body.setAsync(htmlString, {
    coercionType: Office.CoercionType.Html,
  });
